import {noteSvg as Icon__small__noteSvg} from '../Icon__small/Icon__small--note.js';

export var note = {
  name: 'note',
  category: 'icon',
  colorable: true,
  svg: Icon__small__noteSvg,
};
